// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Tp0Ag","colMin":"styles_colMin__bnTu2"};